import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import styled from 'styled-components'

export const ActionsOverlayWrapper = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  transition: opacity 0.3s ease-in-out;

  display: flex;
  flex-direction: column;
  align-items: flex-end;

  cursor: pointer;

  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  &:hover {
    opacity: 1;
  }

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    opacity: 1;
  }
`

export const ActionsContainer = styled.div`
  width: fit-content;
  padding: 8px;
  z-index: 4;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const MainActionTrigger = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
`
